import axios from "axios";

/**
 * Origen del Worker API en producción (sin /api).
 * Definir en .env.production / Pages: VITE_API_URL=https://api.circuitcover.com
 */
const PRODUCTION_API_ORIGIN = "https://api.circuitcover.com";

function configuredApiOrigin(): string {
  return ((import.meta.env.VITE_API_URL as string | undefined)?.trim() || "").replace(/\/$/, "");
}

export function getApiOrigin(): string {
  const configured = configuredApiOrigin();
  if (!import.meta.env.PROD) return configured;
  return configured || PRODUCTION_API_ORIGIN;
}

const apiOrigin = getApiOrigin();
const api = axios.create({
  baseURL: apiOrigin ? `${apiOrigin}/api` : "/api",
  withCredentials: true,
});

/** URL base para assets en R2 (imágenes, PDFs). En prod apunta al Worker. */
export function getAssetsUrl(key: string): string {
  const origin = getApiOrigin();
  const base = origin ? `${origin}/api/assets` : "/api/assets";
  return `${base}/${key.replace(/^\//, "")}`;
}

export default api;
